import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import MicIcon from '@/components/icons/Mic';
import Paragraph, { VARIANT } from '@/components/Paragraph';
import { secondsToMinSec } from '@/utils/helper';
interface Props {
  toggleRecording: VoidFunction;
}
const VoiceRecorder = ({
  toggleRecording
}: Props) => {
  const [timeElapsed, setTimeElapsed] = useState(0);
  const {
    t
  } = useTranslation('askQuestion');
  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setTimeElapsed(prev => prev + 1);
    }, 1000);
    return () => window.clearInterval(intervalId);
  }, []);
  return <div className="bg-black/70 fixed flex items-center inset-0 p-4 z-50" data-sentry-component="VoiceRecorder" data-sentry-source-file="VoiceRecorder.tsx">
      <section className="bg-white h-fit max-w-sm mx-auto p-4 pt-6 relative rounded-xl w-full">
        <div className="bg-primary-70/30 h-20 mx-auto p-3 rounded-full w-20">
          <div className="bg-primary-70 h-full p-3 rounded-full w-full">
            <MicIcon className="fill-transparent stroke-white" data-sentry-element="MicIcon" data-sentry-source-file="VoiceRecorder.tsx" />
          </div>
        </div>
        <Paragraph className="mt-1.5 mx-auto text-neutral-60 w-fit" isHighlighted variant={VARIANT.BIG} data-sentry-element="Paragraph" data-sentry-source-file="VoiceRecorder.tsx">
          {secondsToMinSec(timeElapsed)}
        </Paragraph>
        <Paragraph className="mt-2 mx-auto text-neutral-60 w-fit" isHighlighted variant={VARIANT.BIG} data-sentry-element="Paragraph" data-sentry-source-file="VoiceRecorder.tsx">
          {t('speak')}
        </Paragraph>
        <button className="bg-primary-100 block font-nato-semibold mt-4 mx-auto py-2.5 rounded-lg text-sm text-white w-32" onClick={toggleRecording}>
          {t('confirm')}
        </button>
      </section>
    </div>;
};
export default VoiceRecorder;